import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import {
  attachPurchaseOrderServiceRequest,
  removePurchaseOrderServiceRequest,
  getVendors,
} from 'actions/landlordPurchaseOrdersActions';
import { getTicket } from 'actions/maintenanceTicketActions';

import { LinkPurchaseOrders } from 'components/landlord_app/purchase_orders/components/LinkPurchaseOrders';

const BodyContent = styled.div`
  padding: 24px 24px 35px;
  overflow-y: scroll;
  height: inherit;
`;

const PurchaseOrders = ({
  selectedTicket,
  attachPurchaseOrderServiceRequest,
  removePurchaseOrderServiceRequest,
  getVendors,
  getTicket,
  vendors,
}) => {
  const handleSelectPO = purchaseOrderId => {
    let params = {
      service_request_id: selectedTicket.id,
    };
    attachPurchaseOrderServiceRequest(params, purchaseOrderId)
      .then(res => {
        getTicket(selectedTicket.id);
      })
      .catch(err => {
        console.error(err);
      });
  };

  const handleUnlinkPO = purchaseOrderId => {
    removePurchaseOrderServiceRequest(purchaseOrderId, selectedTicket.id)
      .then(res => {
        getTicket(selectedTicket.id);
      })
      .catch(err => {
        console.error(err);
      });
  };

  return (
    <BodyContent>
      <LinkPurchaseOrders
        propertyId={selectedTicket.property_id}
        selectedPurchaseOrders={
          selectedTicket.purchase_orders && selectedTicket.purchase_orders.data
        }
        handleSelectPO={handleSelectPO}
        handleUnlinkPO={handleUnlinkPO}
        getVendors={getVendors}
        vendors={vendors}
      />
    </BodyContent>
  );
};

export default connect(
  store => {
    return { vendors: store.landlordPurchaseOrders.vendors };
  },
  {
    attachPurchaseOrderServiceRequest,
    removePurchaseOrderServiceRequest,
    getTicket,
    getVendors,
  }
)(PurchaseOrders);
